export const brand = {
  name: 'Molded Fortitude Consulting',
  website: 'https://moldedfortitude.com',
  email: 'moldedfortitude@gmail.com',
  tagline: 'Toward healing, justice, and the next seven generations.',
};

export const offer = {
  name: 'Grant-Ready Impact Systems Sprint',
  leadMagnet: '90-Day Impact One-Pager',
  bookingLink: 'https://meet.brevo.com/clayton-williams/mfc-connect',
  onePagerLink: '/one-pagers/grant-ready-impact-systems.html',
};

export const promises = [
  { title: 'Clarity', body: 'A single view of programs, people, reporting, documents, and outcomes.' },
  { title: 'Compliance', body: 'Funder-ready workflows, reporting calendars, document tracking, and audit preparation.' },
  { title: 'Sustainability', body: 'Systems that survive staff changes, funding cycles, and program growth.' },
  { title: 'Relief', body: 'Less manual admin. More time for people, programming, and leadership.' },
];

export const solutions = [
  {
    title: 'Data Harmony & Unified Reporting System',
    problem: 'Data lives across spreadsheets, inboxes, forms, and disconnected tools.',
    solution: 'We create a unified data map, reporting workflow, and governance structure so your team can retrieve information faster, generate cross-program reports, and see performance clearly.',
    outcome: 'Less manual data manipulation. Faster reporting. Better leadership visibility.',
  },
  {
    title: 'Grant Compliance & Audit Readiness Platform',
    problem: 'Each funder has different rules, deadlines, files, and reporting expectations.',
    solution: 'We build automated compliance checklists, document tagging, deadline calendars, and funder-specific reporting workflows.',
    outcome: 'Cleaner audits. Fewer missed requirements. Stronger funder confidence.',
  },
  {
    title: 'Organizational Knowledge Hub',
    problem: 'Critical history, processes, cultural practices, and program knowledge live inside a few people’s heads.',
    solution: 'We build a secure knowledge hub that captures processes, program history, templates, cultural protocols, and staff onboarding materials.',
    outcome: 'Better continuity. Faster onboarding. Less drift when staff change.',
  },
  {
    title: 'Program Insight & Decision Dashboard',
    problem: 'Managers cannot make confident decisions without timely, reliable data.',
    solution: 'We build dashboards that track participant journeys, outcomes, service activity, reporting gaps, and resource needs.',
    outcome: 'Stronger decisions. Better grant justification. Real-time program insight.',
  },
  {
    title: 'Automated Document & Communications Generator',
    problem: 'Staff lose hours writing meeting notes, donor updates, reports, follow-ups, and grant narratives.',
    solution: 'We use structured organizational data to generate accurate first drafts for documents, communications, and funding narratives.',
    outcome: 'Less repetitive writing. More consistent communication. Faster grant preparation.',
  },
];

export const phases = [
  { label: 'Phase 1', title: 'Map', weeks: 'Weeks 1 to 2', items: ['Workflow audit', 'Data source inventory', 'Grant/reporting requirements review', 'Staff pain-point mapping', 'Risk and compliance scan'] },
  { label: 'Phase 2', title: 'Build', weeks: 'Weeks 3 to 8', items: ['Unified reporting structure', 'Forms and intake workflows', 'Compliance calendar', 'Knowledge hub', 'Dashboard foundation', 'Document generation templates'] },
  { label: 'Phase 3', title: 'Train & Transfer', weeks: 'Weeks 9 to 12', items: ['Staff training', 'Workflow documentation', 'Dashboard review', 'Reporting test', 'Leadership handoff', '30-day improvement plan'] },
];

export const organizationTypes = ['Indigenous organization', 'Nonprofit', 'Health or wellness agency', 'Housing or shelter provider', 'Youth-serving organization', 'Cultural organization', 'Employment or training organization', 'Social service agency', 'Other'];
export const adminChallenges = ['Grant reporting', 'Audit preparation', 'Scattered data', 'Manual spreadsheets', 'Staff burnout', 'Knowledge loss', 'Intake tracking', 'Program outcome reporting', 'Donor or funder communications', 'Other'];
export const fundingStatuses = ['Applying for funding', 'Managing active funding', 'Preparing reports', 'Preparing for audit', 'Building internal capacity', 'Not sure yet'];
